import type { Portal } from "./types";

/**
 * Eagerly collect all screenshots under features/user-guide/images/<portal>/<section>/.
 * Vite replaces import.meta.glob at build time, so the result is a plain record
 * { path: bundledUrl }.
 */
const imageModules = import.meta.glob(
	"./images/**/*.{png,jpg,jpeg,gif,svg,webp}",
	{ eager: true, query: "?url", import: "default" },
) as Record<string, string>;

export interface AutoImage {
	name: string;
	src: string;
}

export function getSectionImages(
	portal: Portal,
	sectionKey: string,
): AutoImage[] {
	const prefix = `./images/${portal}/${sectionKey}/`;
	return Object.entries(imageModules)
		.filter(([path]) => path.startsWith(prefix))
		.map(([path, src]) => ({
			name: path.slice(prefix.length),
			src,
		}))
		.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
}
